export default {"src":"/_next/static/media/arrows.1e27ee17.svg","height":119,"width":73};